import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { useEffect } from "react";
import Layout from "@/components/Layout";

function V2Redirect() {
  useEffect(() => { window.location.replace('/v2/index.html'); }, []);
  return null;
}

import HomePageLight from "@/pages/HomePageLight";
import LuminaPage from "@/pages/LuminaPage";
import RevQPage from "@/pages/RevQPage";
import EchoPage from "@/pages/EchoPage";
import IntegrationsPage from "@/pages/IntegrationsPage";
import ContactPage from "@/pages/ContactPage";
import UploadPage from "@/pages/UploadPage";

const pageVariants = {
  initial: { opacity: 0 },
  animate: { opacity: 1, transition: { duration: 0.2, ease: "easeOut" } },
  exit: { opacity: 0, transition: { duration: 0.15, ease: "easeIn" } },
};

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        variants={pageVariants}
        initial="initial"
        animate="animate"
        exit="exit"
      >
        <Routes location={location}>
          <Route path="/" element={<V2Redirect />} />
          <Route path="/archive" element={<HomePageLight />} />
          <Route path="/home-light" element={<Navigate to="/archive" replace />} />
          <Route path="/lumina" element={<LuminaPage />} />
          <Route path="/revq" element={<RevQPage />} />
          <Route path="/echo" element={<EchoPage />} />
          <Route path="/integrations" element={<IntegrationsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/upload" element={<UploadPage />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <AnimatedRoutes />
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
